import script from "./SingleSitePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleSitePage.vue?vue&type=script&setup=true&lang=js"

import "./SingleSitePage.vue?vue&type=style&index=0&id=03ab6ffe&lang=scss&scoped=true"

import exportComponent from "H:\\crm\\crm_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ab6ffe"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QForm,QToolbarTitle,QInput,QSelect,QRadio,QUploader,QToggle,QCardActions,QBtn,QInnerLoading,QSpinnerOrbit});
